import clsx from 'clsx'
import { Icon } from '@iconify/react'

import s from './CreateMenuItem.module.css'

type Props = {
  title: string
  description: string
  imgSrc: string
  children?: React.ReactNode
  onClick?: () => void
  permission?: boolean
  subMenuPlacement?: 'left' | 'right'
}

const CreateMenuItem: React.FC<Props> = ({
  title,
  description,
  imgSrc,
  children,
  onClick,
  permission,
  subMenuPlacement = 'right',
}) => {
  const showLocked = !permission && typeof permission !== 'undefined'

  return (
    <button
      className={s.wrapper}
      onClick={onClick}
      aria-disabled={showLocked} // For click to be working on disabled button
      disabled={typeof permission === 'undefined'} // For disabling clicking when permission is loading
    >
      <div className={s.left}>
        <img src={imgSrc} alt={title} width={72} height={72} />
      </div>
      <div className={s.right}>
        <h5 className={s.title}>{title}</h5>
        <p className={s.description}>{description}</p>
      </div>
      {showLocked && (
        <Icon className={s.lock} icon="lucide:lock" width={16} height={16} />
      )}
      {children && (
        <div className={clsx(s.subMenuWrapper, s[subMenuPlacement])}>
          {children}
        </div>
      )}
    </button>
  )
}

export default CreateMenuItem
